
  export { AutocompleteError, ButtonStyle, Button, ClientDashboard, Checkbox, Form, Formik, FormikControl, InputError, useEffect, 
           useSWR, ErrorPages, axios, API, SendRequest, useRouter, useState, Yup, TRANSLATION, useRef, toastr, Field, 
           CustomToastrAction, PAGE_ANIMATION_OPTIONS, motion, REDIRECT, clearSWRCache} from "@/imports-files/common/common";
  

  export { PRIVACY_POLICY, set_privacy_initial_form_data } from '@/constants/pages/clients/data-privacy/privacy-policy';
  export {SkipModal} from '@/components/skip-modal';

  export { PrivacyPolicyAction } from '@/actions/pages/clients/data-privacy/privacy-policy';

  export { PrivacyPolicyService } from '@/services/pages/clients/data-privacy/privacy-policy';
 
  export { Editor } from '@tinymce/tinymce-react';
  export { ConfirmationModal } from '@/components/confirmation-modal';
  export { closeModalUsingState } from '@/actions/common/close-modal';
  export { default as QuickAdd } from "@/components/quick-add";

  export { default as Plus } from 'public/icons/plus.svg';
  export { default as Exclamation } from "public/icons/exclamation.svg"; 

  export { default as PageStyle } from '@/styles/pages/clients/privacy-policy/_index.module.scss';
  export { SidebarAction } from "@/actions/components/sidebar";
  export { default as PageStyle1} from "@/styles/pages/jobs/profile/_index.module.scss";


 